module.exports = __webpack_public_path__ + "static/demo_featured-52e6fa216c1430d5be299fe9feb19e88.png";